import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../Context/AuthContext";
import { Card, Button, Spinner } from "react-bootstrap";
import { Base_URL } from "../url";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Attendance = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);
  const [attendanceStatus, setAttendanceStatus] = useState();
  const [location, setLocation] = useState({
    latitude: null,
    longitude: null,
    address: null, // will store city name here
    cityOrigin: null,
  });

  // 🧭 Get user's current location and city using Geoapify
  const getLocation = () => {
    if (navigator.geolocation) {
      console.log("yes");

      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const lat = position.coords.latitude;
          const lon = position.coords.longitude;

          try {
            // 🔍 Call Geoapify Reverse Geocoding API
            const geoRes = await axios.get(
              `https://api.geoapify.com/v1/geocode/reverse?lat=${lat}&lon=${lon}&apiKey=ac8a8a05e1194e3a8f0c5a3872610ab1`
            );

            const cityOrigin =
              geoRes.data?.features?.[0]?.properties?.city ||
              geoRes.data?.features?.[0]?.properties?.county ||
              "Unknown";

            const city =
              geoRes.data?.features?.[0]?.properties?.formatted ||
              geoRes.data?.features?.[0]?.properties?.city ||
              geoRes.data?.features?.[0]?.properties?.county ||
              "Unknown";

            setLocation({
              latitude: lat,
              longitude: lon,
              address: city,
              cityOrigin: cityOrigin,
            });

            console.log("📍 Location fetched:", {
              latitude: lat,
              longitude: lon,
              city,
              cityOrigin,
            });
          } catch (err) {
            console.error("Error fetching city:", err);
            toast.error("Unable to fetch city name from coordinates.");
            setLocation({
              latitude: lat,
              longitude: lon,
              address: "Unknown",
            });
          }
        },
        (error) => {
          console.error("Error getting location:", error);
          if (error.code === 1) {
            toast.error(
              "Location access denied. Please enable location permissions and try again."
            );
            // Optionally show a button to retry location access
          } else {
            toast.error(
              "Unable to get location. Please enable location services."
            );
          }
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    } else {
      toast.error("Geolocation is not supported by this browser.");
    }
  };

  useEffect(() => {
    getLocation();
  }, []);

  const handleClock = async (actionType) => {
    try {
      setLoading(true);
      const now = new Date();

      const payload = {
        userId: user?.userId,
        Date: now.toISOString().split("T")[0],
        Time: now.toLocaleTimeString("en-GB", { hour12: false }),
        type: actionType,
        organisationId: user?.organisationId,
        latitude: String(location.latitude),
        longitude: String(location.longitude),
        address: location.address, // ✅ Only city name will go here
        city: location.cityOrigin,
      };

      console.log("🧾 Payload:", payload);

      const endpoint =
        actionType === "clock_in"
          ? `${Base_URL}/Attendance/clockIn`
          : `${Base_URL}/Attendance/clockOut`;

      const res = await axios.post(endpoint, payload);

      if (res.status === 200 && actionType === "clock_in")
        toast.success("Clocked In Successfully");
      else if (res.status === 200 && actionType === "clock_out")
        toast.success("Clocked Out Successfully");
      else toast.error(res.data);

      setStatus(
        actionType === "clock_in"
          ? "You have successfully clocked in!"
          : "You have successfully clocked out!"
      );
    } catch (error) {
      console.error("Error while clocking:", error);
      setStatus("Error while clocking. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const getAttendanceStatus = async () => {
    const res = await axios.get(
      `${Base_URL}/Attendance/GetAttendanceStatus/id?id=${user?.userId}`
    );
    setAttendanceStatus(res.data);
  };

  useEffect(() => {
    getAttendanceStatus();
  }, [status]);

  // Check if location is available
  const isLocationAvailable = location.latitude && location.longitude;

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <button
          style={{
            padding: "10px 20px",
            borderRadius: "10px",
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            cursor: "pointer",
            fontSize: "16px",
          }}
          onClick={() => navigate("/punchInMaster")}
        >
          Go Back
        </button>
      </div>

      <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
        <Card
          style={{ width: "22rem", borderRadius: "12px" }}
          className="shadow"
        >
          <Card.Body className="text-center">
            <h4 className="mb-3">Attendance</h4>
            <p className="text-muted mb-1">
              Logged in as <strong>{user?.username || "Unknown User"}</strong>
            </p>
            <small className="text-muted d-block mb-4">
              User ID in payload: <code>{String(user?.userId ?? "null")}</code>
            </small>

            <p className="text-muted small mb-2">
              📍 Coordinates:{" "}
              {isLocationAvailable
                ? `${location.latitude.toFixed(5)}, ${location.longitude.toFixed(5)}`
                : "Fetching location..."}
            </p>

            <p className="text-muted small mb-1">
              🏙️ City: {location.cityOrigin || "Fetching city..."}
            </p>
            <p className="text-muted small mb-3">
              🏙️ Address: {location.address || "Fetching address..."}
            </p>

            {!isLocationAvailable && (
              <div className="alert alert-warning small mb-3">
                ⚠️ Waiting for location access. Please allow location permissions to clock in/out.
              </div>
            )}

            {loading ? (
              <Spinner animation="border" variant="primary" />
            ) : (
              <div className="d-flex justify-content-around">
                <Button
                  variant="success"
                  onClick={() => handleClock("clock_in")}
                  disabled={
                    attendanceStatus?.punchInStatus || !isLocationAvailable
                  }
                >
                  Clock In
                </Button>
                <Button
                  variant="danger"
                  onClick={() => handleClock("clock_out")}
                  disabled={
                    attendanceStatus?.punchOutStatus || !isLocationAvailable
                  }
                >
                  Clock Out
                </Button>
              </div>
            )}

            {status && <p className="mt-3 text-info">{status}</p>}
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default Attendance;


